import FormField from "./field";

export default class SavedFormField extends FormField {
    constructor(parent, el) {
        super(parent, el);
        this.myAccount = window?.HONDA?.MyAccount;
        this.savedFieldsWrapper = el;
        this.savedFields = this.savedFieldsWrapper.querySelectorAll('.field');
        this.savedFieldsDataWrapper = this.savedFieldsWrapper?.querySelector('.logged_in_state');
        this.savedFieldsFallback = this.savedFieldsWrapper?.querySelector('.logged_out_state');
        this.savedFieldsCta = this.savedFieldsDataWrapper?.querySelector('.cta-link');

        this.fields = [...parent.el.querySelectorAll('.form_field_composite, .form_field')]
                    .filter((f) => !f.parentElement.closest('.form_field_composite'));

        this.myAccountFields = this.fields
                                .filter(f => f.querySelector('[data-my-account]'))
                                .filter(f => !f.classList.contains('form_field_saved'));

        this.myAccountInputs = this.myAccountFields.map(f => f.querySelectorAll('[data-my-account]'));

        this.bind();
        this.toggleSavedFields();
    }

    bind() {
        this.savedFieldsCta.addEventListener('click', (e) => {
            e.preventDefault();

            this.myAccountInputs.forEach(nodelist => {
                [...nodelist].forEach(input => {
                    const textContent = [...this.savedFields].filter(f => f.dataset.myAccount === input.dataset.myAccount)[0].querySelector('.value').textContent;

                    if(input.tagName === 'SELECT') {
                        [...input.options].forEach(opt => {
                            if(opt.value.toLowerCase() === textContent.toLowerCase()) {
                                input.value = opt.value;
                            }
                        })
                    } else {
                        input.value = textContent;
                    }
                });
            });
        });
    }

    toggleSavedFields() {
        if(this?.myAccount?.isLoggedIn()) {
            this.populate();
            this.savedFieldsDataWrapper.classList.remove('hide');
            this.savedFieldsFallback.classList.add('hide');
        } else {
            this.savedFieldsDataWrapper.classList.add('hide');
            this.savedFieldsFallback.classList.remove('hide');
        }
    }

    async populate() {
        if(this.savedFields && this.savedFields.length) {
            const result = await this.myAccount.query('me');

            if(result?.data?.me) {
                const profileData = result.data.me;

                [...this.savedFields].forEach((item) => {
                    const valueHolder = item.querySelector('.value');
                    valueHolder.textContent = profileData?.[item.dataset.myAccount];
                })
            }
        }
    }

    static is(el) {
        return super.is(el) && el.classList.contains('form_field_saved');
    }
}